import { Download } from "lucide-react";
import { AdminCard, AdminHeader } from "./AdminShell";

const exports = [
  ["Products", "products"],
  ["Orders", "orders"],
  ["Payment Submissions", "payment-proofs"],
  ["Customers", "customers"],
  ["Activity Logs", "activity-logs"]
];

export default function ExportPage() {
  return (
    <div>
      <AdminHeader title="Data Export" description="Download lightweight CSV files for the single-store operations you actually use." />
      <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
        {exports.map(([label, type]) => <AdminCard key={type}><h2 className="text-xl font-black">{label}</h2><p className="mt-2 text-sm text-slate-500">Export current {label.toLowerCase()} data as CSV.</p><a className="btn-primary mt-5" href={`/api/admin/export/${type}`}><Download size={16} className="mr-2" />Export CSV</a></AdminCard>)}
      </div>
    </div>
  );
}
